'use client'

import PropTypes from 'prop-types'
import { Modal } from '@repo/ui/Modal'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const ConfirmDialog = ({ show, proceed, confirmation, options, delete: deleteProp }) => {
  const theme = useTheme()
  const isDelete = Boolean(deleteProp ?? options?.delete)
  const { isOutlookAddin } = useGlobalSettingsStore()

  return (
    <div data-testid="ConfirmDialog">
      <Modal
        open={show}
        handleClose={() => proceed(false)}
        title="Confirm"
        sx={{
          maxWidth: isOutlookAddin ? '300px' : '460px',
          maxHeight: 'calc(100% - 24px)',
          overflowY: 'auto',
          zIndex: '7000'
        }}
        theme={theme}
        isConfirm={true}
      >
        <hr
          style={{
            opacity: 0.12,
            borderColor: theme?.palette?.support?.navy || 'black',
            borderTop: 'none',
            marginBottom: '24px'
          }}
        />

        {typeof confirmation === 'string' ? (
          <MUITypography variant="body1" sx={{ mt: 6, mb: 10 }}>
            {confirmation}
          </MUITypography>
        ) : (
          <MUIStack sx={{ mt: 0, mb: 10 }}>{confirmation}</MUIStack>
        )}

        {isDelete ? (
          <MUIStack direction="row" alignItems="center" justifyContent="flex-end" gap={2} sx={{ mt: 6 }}>
            <MUIButton variant="text" sx={{ color: theme.palette.error.main }} onClick={() => proceed(false)}>
              Cancel
            </MUIButton>
            <MUIButton
              variant="contained"
              sx={{
                backgroundColor: theme.palette.error.main,
                ['&:hover']: { backgroundColor: theme.palette.error.dark }
              }}
              onClick={() => proceed(true)}
            >
              Delete
            </MUIButton>
          </MUIStack>
        ) : (
          <MUIStack direction="row" alignItems="center" justifyContent="flex-end" gap={2} sx={{ mt: 6 }}>
            <MUIButton variant="outlined" onClick={() => proceed(false)}>
              Cancel
            </MUIButton>
            <MUIButton variant="contained" onClick={() => proceed(true)}>
              Continue
            </MUIButton>
          </MUIStack>
        )}
      </Modal>
    </div>
  )
}

ConfirmDialog.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  confirmation: PropTypes.any, // arguments of your confirm function
  options: PropTypes.object, // arguments of your confirm function
  delete: PropTypes.bool
}
